<template>
  <div
    id="home"
    class="layout">
    <LayoutHeader :has-bg-color="false" />
    <div class="home">
      <div class="top">
        <img src="../assets/home-bg.jpg" />
        <div class="title">
          让数据智能改变公共出行
        </div>
        <div class="sub-title">
          数据驱动型互联网+交通科技创新型企业
        </div>
      </div>
      <div
        class="center"
        v-if="applicationList && applicationList.length">
        <div
          class="item"
          v-for="(app, index) in applicationList"
          :key="index"
          @click="toUrl(app.appUrl)">
          <div class="open-app-content-left">
            <img
              v-if="app.appPageIcon && app.appPageIcon.length > 20"
              class="icon"
              :src="app.appPageIcon">
            <img
              v-else
              class="icon"
              src="../assets/morentu2.png">
          </div>
          <div class="open-app-content-right">
            <p class="name">
              {{ app.appName }}
            </p>
            <p class="content">
              {{ app.appIntroduce }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="default-center"
        v-if="applicationList && applicationList.length === 0">
        <img
          class="img"
          src="../assets/default_home.png">
        <p>你尚未开通企业应用 拨打400-900-8977立即开通</p>
      </div>
    </div>
  </div>
</template>

<script>
import LayoutHeader from '@/layout/header';
export default {
  name: 'Home',
  components: {LayoutHeader},
  computed: {
    applicationList() {
      if (this.$store.getters['user/applicationList'] instanceof Array) {
        return this.$store.getters['user/applicationList'].filter((item) => {
          return item.appType === 'WEB';
        });
      } else {
        return null;
      }
    },
  },
  methods: {
    toUrl(url) {
      window.location.href = url;
    },
  },
};
</script>

<style lang="scss">
  body {
    background: #F7F7F7;
  }
#home.layout {
  position: relative;
  flex: 1;
  display: flex;
  min-width: 1200px;
  height: 100vh;
  background: #F7F7F7;
  .header {
    color: #fff;
    .right {
      .home-btn {
        color: #fff;
      }
      .ivu-divider {
        background: rgba(255,255,255,.3);
      }
      .iconfont {
        color: #fff;
      }
      .dropdown-menu-btn {
        color: #fff;
      }
      .header-notice {
        svg {
          fill: #ffffff !important;
        }
      }
    }
  }
  .home {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .top {
      position: relative;
      padding-top: 64px;
      display: flex;
      .title {
        font-family: "微软雅黑";
        font-size: 40px;
        color: #ffffff;
        width: 100%;
        text-align: center;
        position: absolute;
        top: 152px;
        left: 0;
      }
      .sub-title {
        font-family: "微软雅黑";
        font-size: 24px;
        color: rgba($color: #ffffff, $alpha: 0.8);
        width: 100%;
        text-align: center;
        position: absolute;
        top: 218px;
        left: 0;
        font-weight: 100;
      }
      img {
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 391px;
      }
    }
    .center {
      position: absolute;
      top: 319px;
      left: 50%;
      display: flex;
      flex-wrap: wrap;
      width: 1200px;
      padding: 28px 0 0 48px;
      margin-left: -600px;
      background: rgba(247, 247, 247, 1);
      border-radius: 8px;
      min-height: 300px;
      margin-bottom: 70px;
      .item {
        position: relative;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        width: 330px;
        height: 136px;
        padding: 28px 20px 28px 24px;
        margin-right: 48px;
        margin-bottom: 24px;
        background: white;
        border-radius: 4px;
        box-shadow: 0 0 10px 0 rgba(0,0,0,0.05);
        cursor: pointer;
        transition: all 0.25s;
        &:hover{
          transition: all 0.25s;
          background: #F5FBFF;
          /*transform: scale(1.01);*/
        }
        .open-app-content-left {
          margin-right: 16px;
          .icon {
            width: 56px;
            height: 56px;
            border-radius: 50%;
          }
        }
        .open-app-content-right {
          .name {
            width: 180px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 20px;
            margin-bottom: 4px;
            color: rgba(0,0,0,0.85);
          }
          .content {
            font-size: 12px;
            color: rgba(0,0,0,0.45);
            overflow : hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
    .default-center {
      position: absolute;
      top: 550px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .img {
        width: 406px;
        height: 196px;
        margin-bottom: 24px;
      }
      p {
        font-size: 14px;
        color: rgba(0,0,0,0.45);
      }
    }
  }
}
</style>
